var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54749 6.85693L12.8332 11.1426M12.8332 11.1426L17.1189 6.85693M12.8332 11.1426V0.856934",
    stroke: "#121216",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4046 7.71387C21.8593 7.71387 22.2953 7.89448 22.6168 8.21597C22.9383 8.53746 23.1189 8.9735 23.1189 9.42815V21.4282C23.1189 21.8828 22.9383 22.3188 22.6168 22.6403C22.2953 22.9618 21.8593 23.1424 21.4046 23.1424H4.26177C3.80711 23.1424 3.37108 22.9618 3.04959 22.6403C2.7281 22.3188 2.54749 21.8828 2.54749 21.4282V9.42815C2.54749 8.9735 2.7281 8.53746 3.04959 8.21597C3.37108 7.89448 3.80711 7.71387 4.26177 7.71387",
    stroke: "#121216",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54749 9.87402L12.8332 17.1426L23.1189 9.87402",
    stroke: "#121216",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteStats);
export default __webpack_public_path__ + "static/media/invite-stats.18900d3c7e777b9ffc850ace7d0378a8.svg";
export { ForwardRef as ReactComponent };